import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Share } from '../../../../core/models/mysec/share';
import { DefaultLogo } from '../../../../core/services/constant';

@Component({
    selector: 'app-share-details',
    templateUrl: './share-details.component.html',
    styleUrls: ['./share-details.component.scss'],
    standalone: false
})
export class ShareDetailsComponent {
  shareDetails: Share;
  defaultLogo = DefaultLogo;

  constructor(private modal: NgbActiveModal) {}

  close() {
    this.modal.dismiss();
  }

  bid() {
    this.modal.close();
  }

  offer() {
    this.modal.close();
  }
}
